import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from '../config';
import IndexationWatches from './IndexationWatches';
import IndexationRunsTable from './IndexationRunsTable';

const RUNS_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'with_pictures', label: 'With new pictures' },
  { value: 'errors', label: 'In error' },
];

export default function Indexation({ fetchWithAuth }) {
  const { t } = useTranslation();
  const [runRows, setRunRows] = useState([]);
  const [runsLoading, setRunsLoading] = useState(true);
  const [runsFilter, setRunsFilter] = useState('all');

  useEffect(() => {
    const fetchRuns = async () => {
      setRunsLoading(true);
      try {
        const response = await fetchWithAuth(`${API_BASE_URL}/api/statistics/indexationRuns?filter=${runsFilter}`);
        const data = await response.json();
        setRunRows(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching indexation runs:', error);
      } finally {
        setRunsLoading(false);
      }
    };

    fetchRuns();
  }, [fetchWithAuth, runsFilter]);

  return (
    <div className="p-6 space-y-8">
      <div>
        <h2 className="text-2xl font-bold mb-2">{t('Indexation')}</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {t('Watched source/client freshness, and recent indexer run history.')}
        </p>
      </div>

      <section>
        <h3 className="text-xl font-bold mb-4">{t('Freshness watch-list')}</h3>
        <IndexationWatches fetchWithAuth={fetchWithAuth} />
      </section>

      <section>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
          <h3 className="text-xl font-bold">{t('Recent indexation runs')}</h3>
          <div className="inline-flex rounded-lg border border-gray-300 dark:border-gray-600 overflow-hidden text-sm">
            {RUNS_FILTERS.map((option) => (
              <button
                key={option.value}
                onClick={() => setRunsFilter(option.value)}
                className={`px-3 py-1.5 ${
                  runsFilter === option.value
                    ? 'bg-blue-500 text-white'
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
              >
                {t(option.label)}
              </button>
            ))}
          </div>
        </div>
        <IndexationRunsTable rows={runRows} loading={runsLoading} />
      </section>
    </div>
  );
}
